module.exports = __webpack_public_path__ + "img/header-weddingRingsDiamonds@2x.62e7eac.jpg";